import {
  TextField,
  Button,
  Box,
  Typography,
  CircularProgress,
  InputLabel,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import * as Yup from "yup";
import axios from "axios";
import { apiJson } from "../../../../api/Api";

const storeSchema = Yup.object({
  name_en: Yup.string().required("Store name is required"),
  contact: Yup.string()
    .matches(/^[0-9+\s()-]{7,15}$/, "Invalid phone number")
    .required("Phone number is required"),
});

const StoreStep = (props) => {
  const { onSuccess } = props;
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState();
  let message = "";

  const showError = () => {
    toast.error(message, {
      position: "bottom-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name_en: user?.store?.name_en || "",
      contact: user?.store?.contact || "",
      country_id: user?.store?.country_id || 1,
    },
    validationSchema: storeSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const response = await apiJson.onboarding.createStore(values);

        if (response.success) {
          toast.success("Store information saved successfully", {
            position: "bottom-right",
          });
          onSuccess();
        } else {
          toast.error(response.message || "Something went wrong", {
            position: "bottom-right",
          });
        }
      } catch (err) {
        toast.error(
          err?.response?.data?.message ||
            "Something went wrong. Please try again.",
          { position: "bottom-right" },
        );
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    apiJson.vendorProfile.getVendor().then((response) => {
      if (response.success) {
        setUser(response.data);
      } else if (!response.status) {
        // eslint-disable-next-line
        message = response.message
          ? response.message !== ""
            ? response.message
            : "something went wrong"
          : "something went wrong";
        showError();
      } else {
        if (response.status >= 400 && response.status < 500) {
          message = response.message
            ? response.message
            : response.errors
              ? response.errors
              : "something went wrong";
          showError();
        } else {
          message = response.message
            ? response.message !== ""
              ? response.message
              : "something went wrong"
            : "something went wrong";
          showError();
        }
      }
    });
  }, []);

  return (
    <Box className="step-wrapper">
      <Typography className="step-title">Store Information</Typography>
      <Typography className="step-subtitle">
        Enter your store name and contact number so customers and our team can
        reach you.
      </Typography>

      <form onSubmit={formik.handleSubmit} className="step-form">
        <TextField
          name="name_en"
          label="Store Name"
          placeholder="Enter your store name"
          fullWidth
          variant="outlined"
          value={formik.values.name_en}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.name_en && Boolean(formik.errors.name_en)}
          helperText={formik.touched.name_en && formik.errors.name_en}
        />

        <TextField
          name="contact"
          label="Phone Number"
          placeholder="e.g. +971 50 000 0000"
          fullWidth
          variant="outlined"
          value={formik.values.contact}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.contact && Boolean(formik.errors.contact)}
          helperText={formik.touched.contact && formik.errors.contact}
        />
        <Box className="step-actions">
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            endIcon={loading && <CircularProgress size={16} color="inherit" />}
          >
            Save & Continue
          </Button>
        </Box>
      </form>
    </Box>
  );
};

export default StoreStep;
